import React, { useState } from 'react';
import StudentDetails from '../selectRefundReasonAndReceipt/StudentDetails';
import { useWizard } from '../../../../../components/wizard/WizardContext';
import RefundDetailsSummary from './RefundDetailsSummary';
import NewReceipts from './NewReceipts';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { initiateRectRefund } from './constant';
import ALoader from '../../../../../views/pages/manage/common/a-loader';
import RectRefundInitSuccessDialog from './RectRefundInitSuccessDialog';
import { studentDetailsLabelFieldMapping } from '../selectRefundReasonAndReceipt/utils';
import { RECTIFICATION_REFUND } from '../../config';

const VerifyDetails = () => {

    const { values } = useWizard();
    const { selectedStudent, dropdowns, rectRefundStep2Data, rectRefundStep3Data, refundType, utils } = values;
    const {additionalStudentDetails = {}} = utils;
    const { collectPayment } = rectRefundStep3Data;

    const [loading, setLoading] = useState(false);
    const [successDialogInfo, setSuccessDialogInfo] = useState({});

    const verifyClickHandler = async () => {
        try {
            setLoading(true);
            const resp = await initiateRectRefund({ selectedStudent, rectRefundStep2Data, rectRefundStep3Data, refundType, additionalStudentDetails });
            if (resp?.code === 200) {
                const {createdOn, createdBy, response = []} = resp?.data ?? {};
                const refundNumber = response?.find(el => el?.refundType === RECTIFICATION_REFUND)?.refundNumber;
                setSuccessDialogInfo({ isOpen: true, createdOn, createdBy, refundNumber });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='d-flex flex-column m-2'>

            {loading && <ALoader position={"fixed"} />}

            <StudentDetails
                studentDetails={selectedStudent}
                // dropdowns={dropdowns?.data}
                labelFieldMappings={studentDetailsLabelFieldMapping(selectedStudent, dropdowns?.data)}
            />

            <RefundDetailsSummary
                rectRefundStep2Data={rectRefundStep2Data}
            />

            {collectPayment?.length > 0 &&
                <NewReceipts newReceipts={collectPayment} />
            }

            <Footer>
                <div>Check student & account details</div>
                <AButton
                    onClick={verifyClickHandler}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Verify and issue refund
                </AButton>
            </Footer>

            <RectRefundInitSuccessDialog
                dialogInfo={successDialogInfo}
            />

        </div>
    );
}

export default VerifyDetails;